// --------------------------------------- Project List

export const ProjectList = [
  {
    img: "",
    title: "🧠 ThriveCare – Mental Wellness",
    description: "Built a modern, secure mental health platform connecting users with licensed therapists and psychiatrists for confidential, evidence-based care. Designed and developed a responsive, mobile-first interface focused on accessibility and user trust. Implemented secure authentication and protected user sessions. Built therapist discovery and profile systems for structured provider listings. Developed scalable backend architecture to support appointments, messaging, and role-based access. Optimized UI/UX for seamless navigation across devices. Focused on privacy, confidentiality, and professional healthcare standards.",
    tech_stack: "Next.js, React.js, MongoDB, Authentication",
    github_url: "",
    demo_url: "https://psyconnect-psi.vercel.app/",
  },
  {
    img: "",
    title: "📸 Andy Luki Jr – Official Photography",
    description: "Designed and developed a premium, brand-focused photography portfolio website for an award-winning professional photographer. Built using React/Next.js with modular, reusable components. Designed a visually immersive gallery layout optimized for high-resolution photography. Implemented smooth scrolling, modern UI transitions, and responsive design. Structured content hierarchy to emphasize awards, credibility, and personal brand authority. Optimized performance for fast media loading without compromising image quality. Deployed on Vercel with production-ready configuration and SEO enhancements.",
    tech_stack: "React.js, Next.js, CSS, Vercel",
    github_url: "",
    demo_url: "https://andylukijr.vercel.app/#portfolio",
  },
  {
    img: "",
    title: "🔧 Nchito App",
    description: "Built Nchito, a service marketplace connecting clients with verified local handymen, enabling search, contact, and service booking by skill and location. Implemented secure authentication, role-based user accounts, and detailed handyman profiles with image uploads and service listings. Developed a scalable backend API using MongoDB (NoSQL) and a modern Next.js frontend. Integrated a map-based discovery system to locate service providers by area. Delivered a mobile-first, accessible UI with smooth UX across devices.",
    tech_stack: "Next.js, MongoDB, React.js",
    github_url: "https://github.com/YOBAH8/YOBAH8",
    demo_url: "https://nchito-siyo-vercel.app/",
  },
  {
    img: "",
    title: "💼 Personal Portfolio",
    description: "A modern, responsive portfolio website showcasing professional work and skills. Features a sleek black and white design with smooth animations including a shaking name effect, continuous marquee scrolling titles, and interactive custom cursor. Built with React.js for dynamic components and styled with CSS for clean, professional aesthetics. Includes sections for projects, contact information, and professional summary with a single-page scrolling layout.",
    tech_stack: "React.js, CSS, JavaScript",
    github_url: "https://github.com/YOBAH8/portfolio-react",
    demo_url: "https://portfolio-react-yobah8-vercel.app",
  },
];

// --------------------------------------- Skills

export const stackList = [
  {
    img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
    name: "HTML",
  },
  {
    img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg",
    name: "CSS",
  },
  {
    img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
    name: "JavaScript",
  },
  {
    img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
    name: "ReactJS",
  },
  {
    img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg",
    name: "Next.js",
  },
  {
    img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg",
    name: "Express.js",
  },
  {
    img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sass/sass-original.svg",
    name: "Scss",
  },
  {
    img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg",
    name: "Git",
  },
  {
    img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg",
    name: "MongoDB",
  },
  {
    img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg",
    name: "MySQL",
  },
  {
    img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/linux/linux-original.svg",
    name: "Linux",
  },
  {
    img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg",
    name: "TypeScript",
  },
  {
    img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
    name: "Node.js",
  },
  {
    img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vercel/vercel-original.svg",
    name: "Vercel",
  },
  {
    img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cplusplus/cplusplus-original.svg",
    name: "C++",
  },
  {
    img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg",
    name: "Java",
  },
  {
    img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/photoshop/photoshop-plain.svg",
    name: "Adobe Suite",
  },
  {
    img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/illustrator/illustrator-plain.svg",
    name: "Corel Draw",
  },
];
